// src/features/tenants/components/TenantTable.tsx
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatPersianNumber } from '../../../app/components/foundation';
import type { TenantTableRow } from '../types/tenant.types';
import { TenantStatusBadge } from './TenantStatusBadge';

export interface TenantTableProps {
  tenants: TenantTableRow[];
  scrollRef?: { current: HTMLDivElement | null };
}

/**
 * Tenant list table. Presentation only — takes its rows as a prop
 * instead of reading useTenantsMock itself, so it stays decoupled
 * from where the data comes from; a later phase's real tenants hook
 * can feed the same `tenants` prop without this component changing.
 * The parent ControlPlaneDataSurface owns the card shell. This component
 * owns only the table and its local horizontal-scroll rail.
 */
export function TenantTable({ tenants, scrollRef }: TenantTableProps) {
  return (
    <div
      ref={(node) => {
        if (scrollRef) scrollRef.current = node;
      }}
      className="vania-tenants-table-scroll"
    >
      <table className="vania-tenants-table">
          <thead>
            <tr>
              <th>نام تننت</th>
              <th>دامنه</th>
              <th>موبایل نماینده</th>
              <th>وضعیت</th>
              <th>پلن</th>
              <th>تعداد کاربران</th>
              <th>تعداد سرویس</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((tenant) => (
              <tr
                key={tenant.id}
                className="vania-tenants-table-row"
              >
                <td className="vania-tenants-table-name">{tenant.name}</td>
                <td className="vania-tenants-table-domain" dir="ltr">
                  {tenant.primaryDomain ?? 'دامنه‌ای ثبت نشده'}
                </td>
                <td dir="ltr">{formatPersianNumber(tenant.representativeMobile)}</td>
                <td>
                  <TenantStatusBadge status={tenant.status} />
                </td>
                <td>{tenant.plan}</td>
                <td>{formatPersianNumber(tenant.usersCount)}</td>
                <td>{formatPersianNumber(tenant.servicesCount)}</td>
                <td>
                  <Link
                    className="vania-tenants-row-action"
                    to={`/tenants/${tenant.id}`}
                    aria-label="مشاهده تننت"
                    title="مشاهده"
                  >
                    <Eye size={14} aria-hidden="true" />
                    <span className="sr-only">مشاهده</span>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
      </table>
    </div>
  );
}
